/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BillingCenter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2Bills from 'DesignSystem/Svgs/Tysiav2Bills/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BillingCenter({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/BillingCenter"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let assignDetailsInsuranceBillingCenterNameValueData = fromData.useDataValue({ viewPath,
context: 'assign_details',
path: 'insurance_billing_center.name',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="BillingCenter.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2Bills
  viewPath={`${viewPath}/Tysiav2Bills`}
 height={14}
 width={14}
 fill={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={10}
 width={120}
 text="Billing Center"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 data="assign_details.insurance_billing_center.name"
 text={assignDetailsInsuranceBillingCenterNameValueData}
/>
</div>
{children}
</React.Fragment>)
}